import { render } from "./CapitulosNoVigentes.vue?vue&type=template&id=6f6e70db&scoped=true"
import script from "./CapitulosNoVigentes.vue?vue&type=script&lang=js"
export * from "./CapitulosNoVigentes.vue?vue&type=script&lang=js"

import "./CapitulosNoVigentes.vue?vue&type=style&index=0&id=6f6e70db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6e70db"]])

export default __exports__